// extracted by mini-css-extract-plugin
export default {"melodyVideo":"YN-z","isFullWidth":"ZN-z","landingPageVideo":"_N-z","play":"aO-z","iframeVideo":"bO-z","playHidden":"cO-z","fullwidth":"dO-z"};